import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { History, Loader2 } from "lucide-react";

export const SendHistoryDialog = ({ open, onOpenChange, groupName, loading, history }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="history-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><History className="w-5 h-5" /> Versand-Verlauf</DialogTitle>
        <DialogDescription>Bereits versendete Rundmails der Gruppe „{groupName}".</DialogDescription>
      </DialogHeader>
      {loading ? (
        <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
      ) : history.length === 0 ? (
        <div className="py-10 text-center text-muted-foreground text-sm" data-testid="history-empty">
          Für diese Gruppe wurde noch keine Rundmail versendet.
        </div>
      ) : (
        <ScrollArea className="max-h-[55vh] pr-3">
          <div className="divide-y">
            {history.map((h) => (
              <div key={h.id} className="py-3" data-testid={`history-row-${h.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <p className="font-medium truncate">{h.subject}</p>
                  <Badge variant="outline" className="shrink-0 text-[11px]">{h.recipients_count} Empf.</Badge>
                </div>
                <p className="text-xs text-muted-foreground mt-1">
                  {new Date(h.sent_at).toLocaleString("de-DE", { dateStyle: "medium", timeStyle: "short" })}
                  {h.sent_by ? ` · ${h.sent_by}` : ""}
                </p>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}
      <DialogFooter>
        <Button onClick={() => onOpenChange(false)}>Schließen</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
